import { initializeApp } from 'firebase/app';
import { initializeFirestore } from 'firebase/firestore';

/**
 * longreads.me reads the same Firebase project as the Long reads app
 * (txty-dev-36cb4 — production, despite the name).
 *
 * There is no auth here on purpose. Every collection this site touches is
 * world-readable under the project's rules (`allow read: if true` on users,
 * book_series, its entries and its comments), so the site needs no session,
 * and never having one is what makes "you must use the app to interact"
 * structurally true rather than a UI convention.
 */
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || 'AIzaSyDGvIFpxKP_VrNQbIo3rJ6uj8j5spXg370',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'txty-dev-36cb4.firebaseapp.com',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || 'txty-dev-36cb4',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'txty-dev-36cb4.appspot.com',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '921839262532',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || '1:921839262532:web:9b57471e6cb3e0caf5d511',
};

const app = initializeApp(firebaseConfig);

/**
 * `initializeFirestore` rather than `getFirestore`, for the long-polling flag.
 *
 * The SDK's default transport is a streaming WebChannel. Plenty of networks —
 * corporate proxies, some mobile carriers, VPNs — allow the connection to open
 * and then silently stall it, and the SDK waits around thirty seconds before
 * deciding to fall back to long polling. The page renders its loading state
 * for that whole time, which reads as "it never loads" even though every query
 * here returns in under 300ms on a good connection. It is invisible to whoever
 * builds the site and brutal for whoever is behind the wrong router.
 *
 * autoDetectLongPolling makes the SDK probe first and pick the transport that
 * actually works, which costs a few milliseconds on a healthy network and
 * removes the stall on a bad one.
 */
export const db = initializeFirestore(app, {
  experimentalAutoDetectLongPolling: true,
});
export default app;
